import type { PermissionStatus } from "hybridweb-permission-checker";
import { detectPlatform } from "./Platform";

// 권한 상태 조회의 플랫폼 분기를 한 곳에 캡슐화한다. hybridweb-permission-checker 의
// 서브패스를 detectPlatform() 결과에 맞춰 동적 import 해서, capacitor 전용 코드가
// web/desktop 청크에 들어가지 않게 한다(기존 Native* 헬퍼의 지연로드 컨벤션과 동일).

export type { PermissionStatus };

/** 위치 권한 상태를 조회한다(프롬프트를 띄우지 않음). */
export async function checkLocationPermission(): Promise<PermissionStatus> {
  const platform = detectPlatform();
  const mod =
    platform === "web"
      ? await import("hybridweb-permission-checker/location/web")
      : platform === "desktop"
        ? await import("hybridweb-permission-checker/location/electron")
        : await import("hybridweb-permission-checker/location/capacitor"); // android/ios
  return mod.check();
}

/** 알림 권한 상태를 조회한다(프롬프트를 띄우지 않음). */
export async function checkNotificationPermission(): Promise<PermissionStatus> {
  const platform = detectPlatform();
  const mod =
    platform === "web"
      ? await import("hybridweb-permission-checker/notification/web")
      : platform === "desktop"
        ? await import("hybridweb-permission-checker/notification/electron")
        : await import("hybridweb-permission-checker/notification/capacitor"); // android/ios
  return mod.check();
}
